export class StartupController {
  constructor($state: any) {
    $state.go('landing');
  }
}

angular.module('capability-ng-global').controller('ngStartupController', StartupController);



// WEBPACK FOOTER //
// ./app/lib/global/views/startup/startup.ts